/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
/* eslint-enable no-restricted-imports */
import { useEffect, useRef, useState } from "react";

/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */

import { useQuery } from "../../utility/useQuery";
import { forgetState } from "./oidcBridgeState";
import { useValidReturnUrlQuery } from "./useValidReturnUrlQuery";

type AccountsLogoutStatus = "loading" | "done" | "error";

/**
 * accounts のログイン状態を落とす
 *
 * auth-op がログアウトの途中でここへ寄る。Firebase のサインアウトは accounts の
 * オリジンにしか及ばないため、crew や CMS のセッション Cookie は残る。
 *
 * これが無いと、auth-op のセッションだけ消えても accounts のログインが残り、
 * SPWN アカウントを2つ持つ利用者が Shopify のログイン先を変えられない。
 */
export const useAccountsLogout = (): AccountsLogoutStatus => {
  const query = useQuery();
  const returnUrl = useValidReturnUrlQuery();
  const [status, setStatus] = useState<AccountsLogoutStatus>("loading");

  /** effect が再実行されても二度サインアウトしない */
  const signingOut = useRef(false);

  useEffect(() => {
    if (signingOut.current) return;
    signingOut.current = true;

    void (async () => {
      try {
        await firebase.auth().signOut();
      } catch (error) {
        console.error(error);
      }

      /*
       * サインアウトの成否によらず消す。ログアウトは往復を打ち切る操作なので、
       * 残しておくと次のログインで死んだ transaction の橋渡しへ引き戻してしまう
       */
      forgetState();

      /*
       * 成功を確かめてから進む。落ちたまま戻すと auth-op と RP は「ログアウト済み」
       * として扱うのに accounts のログインだけが残り、次に橋渡しページへ来た人が
       * 操作なしで前の利用者として認可を通してしまう
       */
      if (firebase.auth().currentUser !== null) {
        setStatus("error");
        return;
      }

      if (returnUrl === undefined) {
        /*
         * 指定されているのに弾かれたなら設定の誤り。auth-op の ISSUER と portal の
         * 許可ドメインがずれると起きる。戻れない以上 auth-op のログアウトは
         * 完了しないので、成功と伝えない
         */
        if (query.get("return_url") !== null) {
          console.error("return_url is not usable");
          setStatus("error");
          return;
        }

        /*
         * 指定が無いのは直接開かれた場合。`/login` へ送ると、そこでログインし直した
         * ときに return_url が無く crew へ飛ばされる（`useLoginAuthenticator`）
         */
        setStatus("done");
        return;
      }

      // 素通りするだけの画面なので履歴に残さない
      window.location.replace(returnUrl);
    })();
  }, [query, returnUrl]);

  return status;
};
